import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import { logout } from '../../actions/user';
import { updateAppState } from '../../actions/applicationState';

import Body from '../../components/Body';
import Heading from '../../components/Heading';
import Footer from '../../components/Footer';
import Paragraph from '../../components/Paragraph';
import DashboardHeader from '../../components/DashboardHeader';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';

let styles;

class ErrorView extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  render() {
    return (
      <Body hasFooter>
        {
          this.props.user.isAuthenticated ? (
            <DashboardHeader
              logoutHandler={this.logoutHandler}
              redirectHandler={this.redirectHandler}
              {...this.props} />
          ) : (<UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />)
        }
        <div className={css(styles.container)}>
          <Heading>Sorry for the inconvenience - our site is being a dog!</Heading>
          <Paragraph>
            We{'\''}ll have everything back online, just as soon as we can.
            But we do have plenty of great pages.
            Have you read <Link to="/story">our story</Link> yet?
          </Paragraph>
        </div>
        <Footer user={this.props.user} />
      </Body>
    );
  }
}

ErrorView.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: window.innerHeight - (Theme.navigation.height + Theme.footer.height),
    width: '100vw',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 150,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorView);



// WEBPACK FOOTER //
// ./src/views/ServerErrorView/index.js